export default [
  {
    path: "/user/users",
    name: "Users",
    component: () => import("@/pages/user/users/Users.vue"),
    meta: {
      title: "我的用户",
      requireAuth: true,
      authority: "user:users"
    },
    redirect: "/user/users/list",
    children: [
      {
        path: "list",
        name: "UserList",
        component: () => import("@/pages/user/users/list/List.vue"),
        meta: {
          title: "我的用户",
          requireAuth: true,
          authority: "user:users"
        }
      },
      {
        path: "tag",
        name: "UserTag",
        component: () => import("@/pages/user/users/list/Tag.vue"),
        meta: {
          title: "标签管理",
          requireAuth: true,
          authority: "user:users"
        }
      }
    ]
  },
  {
    path: "/user/users/mass",
    name: "UsersMass",
    component: () => import("@/pages/user/users/list/Mass.vue"),
    meta: {
      title: "发消息",
      requireAuth: true,
      authority: "user:users"
    }
  },
  {
    path: "/user/users/details",
    name: "UserDetails",
    component: () => import("@/pages/user/users/list/details/Details.vue"),
    meta: {
      title: "用户详情",
      requireAuth: true,
      authority: "user:users"
    },
    redirect: "/user/users/details/comment",
    children: [
      {
        path: "comment",
        name: "UserComment",
        component: () =>
          import("@/pages/user/users/list/details/view/Comment.vue"),
        meta: {
          title: "用户评论",
          requireAuth: true,
          authority: "user:users"
        }
      },
      {
        path: "feedback",
        name: "UserFeedback",
        component: () =>
          import("@/pages/user/users/list/details/view/Feedback.vue"),
        meta: {
          title: "用户反馈",
          requireAuth: true,
          authority: "user:users"
        }
      },
      {
        path: "recoverys",
        name: "UserRecoverys",
        component: () =>
          import("@/pages/user/users/list/details/view/Recoverys.vue"),
        meta: {
          title: "系统消息",
          requireAuth: true,
          authority: "user:users"
        }
      }
    ]
  },
  {
    path: "/user/users/edit",
    name: "UserEdit",
    component: () => import("@/pages/user/users/list/details/Edit.vue"),
    meta: {
      title: "资料编辑",
      requireAuth: true,
      authority: "user:users"
    }
  },
  {
    path: "/user/comment",
    name: "Comment",
    component: () => import("@/pages/user/comment/Comment.vue"),
    meta: {
      title: "用户评论",
      requireAuth: true,
      authority: "user:comment"
    }
  },
  {
    path: "/user/message",
    name: "UserMessage",
    component: () => import("@/pages/user/message/Message.vue"),
    meta: {
      title: "用户消息",
      requireAuth: true,
      authority: "user:message"
    },
    redirect: "/user/message/notification",
    children: [
      {
        path: "notification",
        name: "UserNotification",
        component: () =>
          import("@/pages/user/message/notification/Notification.vue"),
        meta: {
          title: "发送通知",
          requireAuth: true,
          authority: "user:message"
        }
      },
      {
        path: "feedback",
        name: "FeedbackIndex",
        component: () => import("@/pages/user/message/feedback/Feedback.vue"),
        meta: {
          title: "反馈",
          requireAuth: true,
          authority: "user:message"
        }
      }
    ]
  },
  {
    path: "/user/message/mass",
    name: "MassMessage",
    component: () => import("@/pages/user/message/notification/Mass.vue"),
    meta: {
      title: "群发消息",
      requireAuth: true,
      authority: "user:message"
    }
  },
  {
    path: "/user/vipCard",
    name: "VipCard",
    component: () => import("@/pages/user/vipCard/index.vue"),
    meta: {
      title: "会员卡",
      requireAuth: true,
      authority: "user:vipCard"
    }
  },
  {
    path: "/user/vipCard/add",
    name: "VipCardAddOrUpdate",
    component: () => import("@/pages/user/vipCard/addOrUpdate.vue"),
    meta: {
      title: "新建会员卡",
      requireAuth: true,
      authority: "user:vipCard"
    }
  },
  {
    path: "/user/vipCard/edit",
    name: "VipCardAddOrUpdate",
    component: () => import("@/pages/user/vipCard/addOrUpdate.vue"),
    meta: {
      title: "编辑会员卡",
      requireAuth: true,
      authority: "user:vipCard"
    }
  },
  {
    path: "/user/vipCard/detail",
    name: "VipCardDetail",
    component: () => import("@/pages/user/vipCard/detail/index.vue"),
    meta: {
      title: "会员卡详情",
      requireAuth: true,
      authority: "user:vipCard"
    },
    redirect: "/user/vipCard/detail/vipUserManage",
    children: [
      {
        path: "vipUserManage",
        name: "VipUserManage",
        component: () => import("@/pages/user/vipCard/detail/vipUserManage/vipList.vue"),
        meta: {
          title: "会员管理",
          requireAuth: true,
          authority: "user:vipCard"
        }
      }
    ]
  },
  {
    path: "/user/vipCard/detail/addVipUser",
    name: "AddVipUser",
    component: () => import("@/pages/user/vipCard/detail/addVipUser/index.vue"),
    meta: {
      title: "添加会员",
      requireAuth: true,
      authority: "user:vipCard"
    },
    redirect: "/user/vipCard/detail/addVipUser/singleAdd",
    children: [
      {
        path: "singleAdd",
        name: "SingleAdd",
        component: () => import("@/pages/user/vipCard/detail/addVipUser/SingleAdd.vue"),
        meta: {
          title: "单个添加",
          requireAuth: true,
          authority: "user:vipCard"
        }
      },
      {
        path: "batchImport",
        name: "BatchImport",
        component: () => import("@/pages/user/vipCard/detail/addVipUser/BatchImport.vue"),
        meta: {
          title: "批量导入",
          requireAuth: true,
          authority: "user:vipCard"
        }
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/module/user.js